import { useMemo } from "react";

interface AudioWaveformProps {
  audioLevel: number; // 0-1
  isActive: boolean;
  barCount?: number;
}

export function AudioWaveform({ 
  audioLevel, 
  isActive, 
  barCount = 80 
}: AudioWaveformProps) {
  // Generate random base heights for each bar (stable across renders)
  const baseHeights = useMemo(() => {
    return Array.from({ length: barCount }, () => 
      Math.random() * 0.6 + 0.2 // Random between 0.2 and 0.8
    );
  }, [barCount]);

  return (
    <div className="mx-2 flex h-6 flex-grow items-center justify-center">
      {baseHeights.map((baseHeight, index) => {
        // Calculate height based on activity
        const heightMultiplier = isActive 
          ? baseHeight + audioLevel * (1 - baseHeight) // Scale up with audio level
          : baseHeight * 0.5; // Static lower height when inactive
        
        const height = Math.max(2, heightMultiplier * 20); // Min 2px, max 20px
        
        return (
          <div
            key={index}
            className={`mx-[2px] w-[3px] rounded-full transition-all duration-75 ${
              isActive 
                ? "bg-primary/50" 
                : "bg-primary/20 dark:bg-primary/30"
            }`}
            style={{ 
              height: `${height}px`,
              transitionProperty: "height, background-color",
            }}
          />
        );
      })}
    </div>
  );
}
